module.exports = __webpack_public_path__ + "static/media/mausam - heavy rain.0f8ca7ca.png";